import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import Navigation from '../components/Navigation';
import AttributePlayersTable from '../components/AttributePlayersTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';

import PlayerPickerModal from '../components/PlayerPickerModal';

import axios from 'axios';
import {
    Col,
    Row,
    Button,
    FormControl,
    FormGroup,
    InputGroup
} from 'react-bootstrap';

import { translate } from 'react-i18next';

import './AttributePlayers.css';

class AttributePlayers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            userIsAuthorized: props.userIsAuthorized,
            players: [],
            attribute: {},
            page: props.page,
            pageCount: 0,
            limit: 40,
            search: props.search,
            selected: props.selected - 1,
            showingModal: false,
            // Individual selection mode: tracks which specific players are selected
            selectedPlayers: new Set(),              // UUIDs of individually selected players
            selectedPlayersData: new Map(),          // UUID -> player object data for selected players
            // Select-all mode: tracks global selection with exclusions
            selectAllMode: false,                    // true = "select all", false = individual selection
            totalPlayers: 0,                         // total count across all pages
            excludedPlayers: new Set(),              // UUIDs of players excluded from "select all"
            excludedPlayersData: new Map()           // UUID -> player object data for excluded players
        };
    }

    componentDidMount() {
        this.loadAttributeInformation();
        this.loadAttributePlayersFromServer();
    }

    handleAddClicked() {
        this.setState({ showingModal: true });
    }

    hideModal() {
        this.setState({ showingModal: false });
    }

    didPickPlayers(items) {
        this.setState({ showingModal: false });
        const { uuid, attributeUUID } = this.props.match.params;

        console.log(`Selected Items: ${JSON.stringify(items)}`);

        var self = this;
        axios
            .post(
                `${
                    config.baseURL
                }/organisations/${uuid}/attributes/${attributeUUID}/players`,
                {
                    playerUUIDs: items
                }
            )
            .then(function(response) {
                self.loadAttributePlayersFromServer();
            })
            .catch(function(err) {
                console.log('Error');
            });
    }

    deletePlayer(player) {
        const { uuid, attributeUUID } = this.props.match.params;

        var self = this;
        axios
            .delete(
                `${config.baseURL}/players/${
                    player.uuid
                }/attributes/${attributeUUID}`
            )
            .then(function(response) {
                self.loadAttributePlayersFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadAttributeInformation() {
        var self = this;

        const { uuid, attributeUUID } = this.props.match.params;

        axios
            .get(
                `${
                    config.baseURL
                }/organisations/${uuid}/attributes/${attributeUUID}`,
                {}
            )
            .then(function(response) {
                self.setState({
                    attribute: response.data.attribute
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadAttributePlayersFromServer() {
        var self = this;
        const { uuid, attributeUUID } = this.props.match.params;

        axios
            .get(
                `${
                    config.baseURL
                }/organisations/${uuid}/attributes/${attributeUUID}/players`,
                {
                    params: {
                        page: self.state.page,
                        limit: self.state.limit,
                        search: self.state.search
                    }
                }
            )
            .then(function(response) {
                self.setState({
                    players: response.data.players,
                    pageCount: response.data.pageCount,
                    totalPlayers: response.data.itemCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url); 

        this.setState({ page: selected, selected: data.selected }, () => {

            this.loadAttributePlayersFromServer();
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');
        }
        window.history.pushState(null, null, url);

        event.preventDefault();
        this.loadAttributePlayersFromServer();
    };

    handleSelectPlayer = (playerUuid, isSelected) => {
        let selectedPlayers = new Set(this.state.selectedPlayers);
        let selectedPlayersData = new Map(this.state.selectedPlayersData);
        let excludedPlayers = new Set(this.state.excludedPlayers);
        let excludedPlayersData = new Map(this.state.excludedPlayersData);
        
        if (isSelected) {
            if (this.state.selectAllMode) {
                // In "select all" mode: checking a box means "un-exclude" this item
                // Remove from exclusion list so it gets included in bulk operation
                excludedPlayers.delete(playerUuid);
                excludedPlayersData.delete(playerUuid);
            } else {
                // In individual mode: checking a box means "select" this item
                // Add to individual selection list
                selectedPlayers.add(playerUuid);
                const playerData = this.state.players.find(player => player.uuid === playerUuid);
                if (playerData) {
                    selectedPlayersData.set(playerUuid, playerData);
                }
            }
        } else {
            if (this.state.selectAllMode) {
                // In "select all" mode: unchecking a box means "exclude" this item
                // Add to exclusion list so it gets skipped in bulk operation
                excludedPlayers.add(playerUuid);
                const playerData = this.state.players.find(player => player.uuid === playerUuid);
                if (playerData) {
                    excludedPlayersData.set(playerUuid, playerData);
                }
            } else {
                // In individual mode: unchecking a box means "deselect" this item
                // Remove from individual selection list
                selectedPlayers.delete(playerUuid);
                selectedPlayersData.delete(playerUuid);
            }
        }
        
        this.setState({ 
            selectedPlayers, 
            selectedPlayersData,
            excludedPlayers,
            excludedPlayersData
        });
    };

    handleSelectAll = (isSelectAll) => {
        if (isSelectAll) {
            this.setState({ 
                selectAllMode: true,
                selectedPlayers: new Set(),
                selectedPlayersData: new Map(),
                excludedPlayers: new Set(),
                excludedPlayersData: new Map()
            });
        } else {
            this.setState({ 
                selectAllMode: false,
                selectedPlayers: new Set(),
                selectedPlayersData: new Map(),
                excludedPlayers: new Set(),
                excludedPlayersData: new Map()
            });
        }
    };

    showBulkDeleteConfirmation = () => {
        const { t } = this.props;
        
        let bodyContent;
        
        if (this.state.selectAllMode) {
            const effectiveCount = this.state.totalPlayers - this.state.excludedPlayers.size;
            bodyContent = (
                <div>
                    <p><strong>Warning: This will remove {effectiveCount} players from this attribute!</strong></p>
                    <p>This includes all players that match your current search {this.state.search ? ` for "${this.state.search}"` : ''}
                    {this.state.excludedPlayers.size > 0 && <span>, excluding {this.state.excludedPlayers.size} manually deselected items</span>}.</p>
                    <p><em>This action cannot be undone.</em></p>
                </div>
            );
        } else {
            const selectedItems = Array.from(this.state.selectedPlayersData.values());
            bodyContent = (
                <div>
                    <p><strong>This will remove {selectedItems.length} selected players from this attribute:</strong></p>
                    <ul style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
                        {selectedItems.map(item => (
                            <li key={item.uuid}><strong>{item.name}</strong></li>
                        ))}
                    </ul>
                </div>
            );
        }
        
        this.dialog.show({
            title: t('Dialog.warning'),
            body: bodyContent,
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => this.dialog.hide(),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.remove'),
                    () => this.confirmBulkDelete(),
                    'btn-danger'
                )
            ],
            bsSize: 'large'
        });
    };

    handleBulkDelete = () => {
        this.showBulkDeleteConfirmation();
    };

    confirmBulkDelete = () => {
        const { uuid, attributeUUID } = this.props.match.params;
        
        const payload = {
            selectAll: this.state.selectAllMode,
            search: this.state.search,
            players: this.state.selectAllMode ? [] : Array.from(this.state.selectedPlayers),
            excludedPlayers: this.state.selectAllMode ? Array.from(this.state.excludedPlayers) : []
        };
        
        const wasSelectAllWithSearch = this.state.selectAllMode && this.state.search;
        
        axios
            .post(`${config.baseURL}/organisations/${uuid}/attributes/${attributeUUID}/players/bulk-delete`, payload)
            .then((response) => {
                const newState = { 
                    selectedPlayers: new Set(),
                    selectedPlayersData: new Map(),
                    excludedPlayers: new Set(),
                    excludedPlayersData: new Map(),
                    selectAllMode: false 
                };

                if (wasSelectAllWithSearch) {
                    newState.search = '';
                    
                    const url = new URL(window.location.href);
                    url.searchParams.delete('search');
                    window.history.pushState(null, null, url);
                }

                // Set all state at once, then reload
                this.setState(newState, () => {
                    this.loadAttributePlayersFromServer();
                });
                
                this.dialog.hide();
            })
            .catch(error => {
                console.log(error);
            });
    };

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'AttributePlayers.title'
        )}`;

        const user = this.state.user;
        const { uuid, attributeUUID } = this.props.match.params;
        const attributepath = this.props.emailAttribute ? "emailattributes" : "attributes";

        // Calculate effective selection count based on mode:
        // - selectAllMode: total items minus excluded items = "select all except these"
        // - individual mode: just count the individually selected items
        const selectedCount = this.state.selectAllMode 
            ? this.state.totalPlayers - this.state.excludedPlayers.size 
            : this.state.selectedPlayers.size;
        const hasSelection = selectedCount > 0;

        return (
            <div className="AttributePlayers">
                <Dialog ref={el => { this.dialog = el; }} />
                <PlayerPickerModal
                    show={this.state.showingModal}
                    singleSelection={false}
                    onHide={this.hideModal.bind(this)}
                    organisationUUID={uuid}
                    excludeAttribute={attributeUUID}
                    onChoose={this.didPickPlayers.bind(this)}
                    user={this.state.user}
                    userIsAuthorized={this.state.userIsAuthorized}
                />
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('AttributePlayers.title')}{' '}
                                    <small>{this.state.attribute.name}</small>
                                    {this.state.userIsAuthorized(user, [
                                        'staff_super_admin',
                                        'staff_admin',
                                        'organisation_admin',
                                        'organisation_user'
                                    ]) ? (
                                        <Button
                                            type="submit"
                                            className="btn btn-primary"
                                            onClick={() =>
                                                this.handleAddClicked()
                                            }
                                        >
                                            <em className="fa fa-plus fa-fw" />{' '}
                                            {t('Players.add_player')}
                                        </Button>
                                    ) : null}
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-tachometer-alt" />{' '}
                                        <Link to={`/organisations/${uuid}`}>
                                            {t('Dashboard.title')}
                                        </Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-tags" />{' '}
                                        <Link
                                            to={`/organisations/${uuid}/${attributepath}`}
                                        >
                                          {this.props.emailAttribute ? (

                                            t('SideNavigation.emailattributes')

                                            ) :  t('SideNavigation.attributes')}
                                        </Link>
                                    </li>
                                    <li className="active">
                                        <i className="fa fa-tv" />{' '}
                                        {t('SideNavigation.players')}
                                    </li>
                                </ol>

                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '15px' }}>
                                                    <form
                                                        role="search"
                                                        onSubmit={this.handleSubmit}
                                                        style={{ flex: hasSelection ? 1 : 1 }}
                                                    >
                                                        <FormGroup controlId="search" style={{ margin: 0 }}>
                                                            <InputGroup style={{ height: '38px' }}>
                                                                <FormControl
                                                                    type="text"
                                                                    value={this.state.search}
                                                                    onChange={this.handleChange}
                                                                    placeholder={t('Search')}
                                                                    style={{ height: '38px' }}
                                                                />
                                                                <InputGroup.Button>
                                                                    <Button 
                                                                        onClick={this.handleSubmit}
                                                                        style={{ height: '38px' }}
                                                                    >
                                                                        <i className="glyphicon glyphicon-search" />
                                                                    </Button>
                                                                </InputGroup.Button>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </form>

                                                    {hasSelection && (
                                                        <div className="alert alert-info" style={{ 
                                                            display: 'flex', 
                                                            justifyContent: 'space-between', 
                                                            alignItems: 'center', 
                                                            margin: 0, 
                                                            padding: '8px 16px',
                                                            fontSize: '14px',
                                                            whiteSpace: 'nowrap',
                                                            flex: 2,
                                                            minWidth: '350px',
                                                            height: '38px',
                                                            borderRadius: '4px'
                                                        }}>
                                                            <span>
                                                                <strong>{selectedCount}</strong> player(s) selected
                                                                {this.state.selectAllMode && <span> (all pages)</span>}
                                                            </span>
                                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                                <Button 
                                                                    className="btn-default btn-sm"
                                                                    onClick={() => {
                                                                        this.setState({ 
                                                                            selectedPlayers: new Set(),
                                                                            selectedPlayersData: new Map(),
                                                                            excludedPlayers: new Set(),
                                                                            excludedPlayersData: new Map(),
                                                                            selectAllMode: false 
                                                                        });
                                                                    }}
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <em className='far fa-square' /> {t('MediaSnippetMediaLibrary.select_none')}
                                                                </Button>
                                                                <Button 
                                                                    className="btn-danger btn-sm"
                                                                    onClick={this.handleBulkDelete}
                                                                    style={{ fontSize: '12px' }}
                                                                >
                                                                    <em className="fa fa-trash" /> Remove Selected
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >
                                    <AttributePlayersTable
                                        userIsAuthorized={
                                            this.state.userIsAuthorized
                                        }
                                        user={this.state.user}
                                        players={this.state.players}
                                        uuid={uuid}
                                        onDelete={this.deletePlayer.bind(this)}
                                        selectedPlayers={this.state.selectedPlayers}
                                        selectAllMode={this.state.selectAllMode}
                                        excludedPlayers={this.state.excludedPlayers}
                                        onSelectPlayer={this.handleSelectPlayer}
                                        onSelectAll={this.handleSelectAll}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(AttributePlayers);
